import { Moment } from 'moment-timezone';
import { TimeIn12HourClock } from 'ui/datePicker';
import { StartNodeData } from 'modules/workflows/types';

export type SRLNodeData = Partial<StartNodeData> &
  Required<
    Pick<StartNodeData, 'minuteOfDay' | 'recurDays' | 'skipDaysOfWeek' | 'startDate' | 'timeZone'>
  > &
  Pick<StartNodeData, 'endDate' | 'maxStartTimeOffsetInMinutes'>;

export interface SRLStateValues extends Pick<SRLNodeData, 'timeZone' | 'skipDaysOfWeek'> {
  minStart: Moment;
  momentStart: Moment;
  momentStartTime: Moment;
  momentEnd: Moment | null;
  recurDays: string;
}

/** State values, formatted for UI */
export interface SchedulerFormStateValues
  extends Pick<SRLNodeData, 'timeZone' | 'recurDays' | 'maxStartTimeOffsetInMinutes'> {
  minuteOfDay: TimeIn12HourClock;
  startDate: Moment;
  endType?: EndRecurrenceType;
  endDate?: Moment;
  recurrence: RecurrenceScheduleType;
  skipDaysOfWeek: Day[];
}

/** A day of the week */
export enum Day {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

/**
 * Supported `RecurrenceSchedule` types
 */
export enum RecurrenceScheduleType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  BiWeekly = 'BiWeekly',
  ThirtyDays = 'ThirtyDays',
  DoNotRepeat = 'DoNotRepeat',
  Custom = 'Custom',
}

/**
 * Supported End types
 */
export enum EndRecurrenceType {
  Never = 'Never',
  OnDate = 'OnDate',
}
